import DetailNavTitle from '@/components/business/detail-nav-title';
import React, {useCallback} from 'react';
import {debounce, goBack, goTo} from '@/utils';
import {View} from 'react-native';
import theme from '@/style';
import Spin from '@/components/basic/spin';
import ProgressBar from './components/progress';
import ColorTime from './color-time-remaining';
import ColorQuick from './color-quick';
import ColorBalls from './color-ball';
import ColorBets from './color-bets';
import {Bets} from '@/components/business/games';
import {Times} from '@/components/business/games/times-list';
import Drawer, {DrawerRef} from '@/components/basic/game-drawer/game-drawer';
import {
  BetsInfo,
  ColorGetAllResponse,
  // ColorGetLatestContentResponse,
  // ColorGetNearestLotteryResponse,
  create,
  getAll,
  getOrderByIssueNo,
  getColorConfig,
  getCountdownFromCycle,
  // getResult,
} from './color-service';
import {BasicObject} from '@/types';
import ColorTab from './color-tabs/color-tab';
import RuleModal from '@/components/business/games/rule';
import ColorRule from './color-rules';
import ColorSaleRule from './color-sale-rule';
import Ball, {BallProps} from './components/ball';
import globalStore from '@/services/global.state';
import {useTranslation} from 'react-i18next';
import {
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import GoldWin from '@/components/business/games/gold-win';
import {checkIsShown, saveIssueNum} from '@/components/utils/gameWin';
import Video from '@/components/basic/video';
import {ScrollView} from 'react-native-gesture-handler';
import ColorTabView from './color-tabs/color-tab-veiw';
import {getCycle} from '../dice/dice';
const ColorGame = () => {
  const {params = {}} = useRoute() as BasicObject;
  const {colorId} = params as {colorId?: number};
  const drawerRef = React.useRef<DrawerRef>(null);
  const [configs, setConfigs] = React.useState<ColorGetAllResponse[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [currentConfig, setCurrentConfig] =
    React.useState<ColorGetAllResponse | null>();
  const [currentLottery, setCurrentLottery] = React.useState<any>();
  const [latestLottery, setLatestLottery] = React.useState<any>();
  const [currentTime, setCurrentTime] = React.useState(-1);
  const [disabled, setDisabled] = React.useState(false);
  const [ruleVisible, setRuleVisible] = React.useState(false);
  const [saleRuleVisible, setSaleRuleVisible] = React.useState(false);
  const [showWin, setShowWin] = React.useState(false);
  const [betsInfo, setBetsInfo] = React.useState<BetsInfo>();
  const lockToast = React.useRef(false);
  const {i18n} = useTranslation();
  const [betsList, setBetsList] = React.useState<{
    [key: string]: BallProps[];
  }>({});
  const [winPaused, setWinPaused] = React.useState(true);
  const [winAmount, setWinAmount] = React.useState(0);
  const [refreshCode, setRefreshCode] = React.useState(0);
  const refreshCodeRef = React.useRef(0);
  const [cutdownTime, setCutdownTime] = React.useState(0);
  const [timeVersion, setTimeVersion] = React.useState(0);
  const {getState} = useNavigation();
  const {index: stateIndex, routes} = getState();
  const totalOrder = React.useRef(0);
  const [orderNum, setOrderNum] = React.useState(0);
  const currentRouteName = routes[stateIndex].name;

  React.useEffect(() => {
    setLoading(true);
    getGameConfig().then();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUpdateAmount = useCallback(() => {
    if (globalStore.token) {
      globalStore.updateAmount.next({gameType: 'Color'});
    }
  }, []);
  useFocusEffect(handleUpdateAmount);

  const getGameConfig = async () => {
    const res = await getAll();
    if (res) {
      setConfigs(res);
      if (colorId) {
        const find = res.find(item => item.id === Number(colorId));
        setCurrentConfig(find);
      } else {
        setCurrentConfig(res[0]);
      }
    }
  };

  React.useEffect(() => {
    if (currentConfig?.id) {
      getGameData(currentConfig.id);
    }
  }, [currentConfig]);

  const getGameData = async (configId: number) => {
    try {
      setLoading(true);
      // 使用新的 getColorConfig 接口，同时获取当前期和最新期信息
      const resConfig = await getColorConfig(configId);
      console.log('resConfig', resConfig);

      if (resConfig?.current) {
        // 如果接口返回的 countdownTime 为 0，则根据 cycle 计算倒计时
        let finalCountdownTime = resConfig.current.countdownTime;
        if (finalCountdownTime === 0) {
          finalCountdownTime = getCountdownFromCycle(resConfig.current.cycle);
          console.log('接口返回countdownTime为0，使用cycle计算:', {
            cycle: resConfig.current.cycle,
            calculatedCountdown: finalCountdownTime,
          });
        }

        const currentLotteryData = {
          ...resConfig.current,
          cycle: getCycle(resConfig.current.cycle),
          countdownTime: finalCountdownTime, // 使用处理后的倒计时
          // dataStatus: resConfig.current.dataStatus || 1,
          // status: resConfig.current.status || 1,
          // bulletinBoard: resConfig.current.bulletinBoard || '',
          // id: resConfig.current.id || 0,
          // rank: resConfig.current.rank || 0,
        };
        setCurrentLottery(currentLotteryData);
        setCutdownTime(() => finalCountdownTime);
        setTimeVersion(v => v + 1);
      }

      if (resConfig?.latestOne) {
        const latestLotteryData = {
          ...resConfig.latestOne,
          cycle: getCycle(resConfig.latestOne.cycle),
          digitResult: resConfig.latestOne.digitResult || '',
          colorResult: resConfig.latestOne.colorResult || '',
          // createTime: resConfig.latestOne.createTime || 0,
          // id: resConfig.latestOne.id || 0,
          // updateTime: resConfig.latestOne.updateTime || 0,
        };
        setLatestLottery(latestLotteryData);
      }
    } finally {
      setLoading(false);
      setDisabled(false);
      lockToast.current = false;
    }
  };

  React.useEffect(() => {
    if (latestLottery) {
      getOpenResult(latestLottery.issueNo);
    }
  }, [latestLottery]);

  const getOpenResult = async (issueNo: string) => {
    try {
      const res = await getOrderByIssueNo(issueNo);
      if (res && res.awardAmount) {
        // 中奖
        const isShown = await checkIsShown('color', issueNo);
        if (!isShown) {
          setWinAmount(res.awardAmount);
          setShowWin(true);
          setWinPaused(false);
          globalStore.updateAmount.next({gameType: 'Color'});
          saveIssueNum('color', issueNo);
        }
      }
    } finally {
    }
  };

  const updateColorPayOrder = (issNo: string, info: BallProps) => {
    const current = betsList[issNo] || [];
    current.push(info);
    const target = Object.assign({}, betsList, {[issNo]: [...current]});
    setBetsList(target);
  };

  const onBetsSubmit = async (totalPrice: number) => {
    try {
      if (!globalStore.token) {
        drawerRef.current?.close();
        goTo('Login');
        return;
      }
      if (disabled) {
        return;
      }
      if (betsInfo && currentLottery) {
        globalStore.globalLoading.next(true);
        const res = await create({
          issueNo: currentLottery?.issueNo,
          basePrice: totalPrice,
          num: 1,
          amount: totalPrice,
          selectType: betsInfo?.onlyColor ? 2 : 1,
          selectValue: betsInfo?.digit,
        });
        if (res) {
          globalStore.globalSucessTotal(i18n.t('paidSuccess.label.subTitle'));
          if (index !== 3) {
            totalOrder.current += 1;
            setOrderNum(totalOrder.current);
          }
          globalStore.updateAmount.next({gameType: 'Color'});
          drawerRef.current?.close();
          updateColorPayOrder(currentLottery?.issueNo, {
            digit: betsInfo.digit,
            color: betsInfo.color,
            onlyColor: betsInfo?.onlyColor,
          });
        }
      }
    } finally {
      globalStore.globalLoading.next(false);
    }
  };

  const onBetsSubmitCheck = debounce((totalPrice: number) => {
    onBetsSubmit(totalPrice);
  }, 200);

  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    if (index === 3 && totalOrder.current) {
      totalOrder.current = 0;
      setOrderNum(0);
    }
  }, [index]);

  return (
    <View style={[theme.background.lightGrey, theme.flex.flex1]}>
      <DetailNavTitle
        title={'Color Prediction'}
        hideServer={true}
        onBack={() => goBack()}
      />
      <Spin loading={loading} style={[theme.flex.flex1, theme.flex.basis0]}>
        <ScrollView stickyHeaderIndices={[6]}>
          {configs.length > 1 ? (
            <Times
              onTimePress={id => {
                const find = configs.find(pie => pie.id === id);
                setCurrentConfig(find);
              }}
              minutes={configs}
              configId={currentConfig?.id}
            />
          ) : (
            <View />
          )}
          <ColorTime
            digit={latestLottery?.digitResult}
            showRule={() => setRuleVisible(true)}
            countdownTime={cutdownTime}
            stopBetSec={currentLottery?.minRemainingSecond || 10}
            prevIssueNum={latestLottery?.issueNo}
            cycle={getCycle(currentLottery?.cycle || 0)}
            issueNumber={currentLottery?.issueNo}
            isSameRoute={currentRouteName === 'Color'}
            onDisabled={() => {
              drawerRef.current?.close();
              setDisabled(true);
            }}
            timeVersion={timeVersion}
            onTimeEnd={() => {
              if (currentConfig?.id) {
                setTimeout(() => {
                  getGameData(currentConfig.id);
                  refreshCodeRef.current += 1;
                  setRefreshCode(refreshCodeRef.current);
                }, 1000);
              }
            }}
            onTimeChange={setCurrentTime}
          />
          <ProgressBar
            value={currentTime}
            total={currentLottery?.cycle ? currentLottery?.cycle * 60 : 1}
          />
          <ColorQuick
            disabled={disabled}
            onColorPress={info => {
              setBetsInfo(info);
              setTimeout(() => {
                drawerRef.current?.open();
              }, 0);
            }}
          />
          <ColorBalls
            disabled={disabled}
            onBets={info => {
              setBetsInfo(info);
              setTimeout(() => {
                drawerRef.current?.open();
              }, 0);
            }}
          />
          <ColorBets
            betsBall={
              currentLottery?.issueNo ? betsList[currentLottery?.issueNo] : []
            }
          />
          <ColorTab index={index} setIndex={setIndex} orderNum={orderNum} />
          <ColorTabView
            refreshCode={refreshCode}
            configId={currentConfig?.id!}
            index={index}
          />
        </ScrollView>
      </Spin>
      <Drawer
        beforeClose={() => {}}
        ref={drawerRef}
        mode="bottom"
        contentBackgroundColor="#0000">
        <Bets
          BallEle={
            <Ball
              ballSize={64}
              fontSize={betsInfo?.onlyColor ? 14 : 24}
              digit={betsInfo?.digit || ''}
              color={betsInfo?.color}
              fontColor={betsInfo?.onlyColor ? theme.basicColor.white : '#000'}
              onlyColor={Boolean(betsInfo?.onlyColor)}
            />
          }
          onBitSubmit={onBetsSubmitCheck}
          onSeeRule={() => setSaleRuleVisible(true)}
          onClose={() => drawerRef.current?.close()}
        />
      </Drawer>
      <RuleModal
        title="Rule"
        visible={ruleVisible}
        onClose={() => setRuleVisible(false)}>
        <ColorRule tabsInfo={configs} />
      </RuleModal>
      <RuleModal
        title="Rule"
        visible={saleRuleVisible}
        onClose={() => setSaleRuleVisible(false)}>
        <ColorSaleRule />
      </RuleModal>
      <GoldWin
        amount={winAmount}
        visible={showWin}
        onClose={() => {
          setShowWin(false);
        }}
      />
      <Video
        onEnd={() => {
          setWinPaused(true);
        }}
        audioOnly
        source={require('@components/assets/music/win.mp3')}
        src={require('@components/assets/music/win.mp3')}
        paused={winPaused}
      />
    </View>
  );
};

export default ColorGame;
